"use client";

import { useEffect, useRef, useState } from "react";

export default function InViewFill({ percent }: { percent: number }) {
  const ref = useRef<HTMLDivElement>(null);
  const [filled, setFilled] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setFilled(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) setFilled(true);
      },
      { threshold: 0.4 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      role="progressbar"
      aria-valuenow={percent}
      aria-valuemin={0}
      aria-valuemax={100}
      className="h-1.5 w-full overflow-hidden rounded-full bg-[var(--af-border)]"
    >
      <div
        className="h-full rounded-full bg-[var(--af-accent)] transition-[width] duration-[1400ms] ease-out motion-reduce:transition-none"
        style={{ width: filled ? `${percent}%` : "0%" }}
      />
    </div>
  );
}
